import { useRef } from "react"
import { FormikProps } from "formik"
import { enqueueSnackbar } from "notistack"
import { useNavigate } from "react-router-dom"
import { MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE } from "../../../../../constants/routes"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { CreateUpdateSalesAccountForm } from "../components/CreateUpdateSalesAccountForm"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { createSalesAccount, SalesAccountsQuery } from "../salesAccountsApi"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { prepareInitialValues } from "../helpers/prepareInitialValues"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { SalesAccountBase } from "../salesAccountsTypes"

export function CreateSalesAccount() {
    const navigate = useNavigate()
    const { merchantId } = useMerchant()
    const formRef = useRef<FormikProps<SalesAccountBase>>(null)

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutate: callCreateSalesAccount } = useApiMutation(createSalesAccount, {
        async onSuccess(_, data, context) {
            await context.queryClient.invalidateQueries({ queryKey: [SalesAccountsQuery.LIST] })
            navigate(MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE)
            if (!data.serviceResponse.displayMessage) return
            enqueueSnackbar({
                variant: "success",
                message: data?.serviceResponse.displayMessage,
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="sales-accounts-create-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_CREATE}
                    title="Create sales account"
                    rightElement={
                        <LocalizedStrict id="sales-accounts-form-create-submit-button">
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-settings-header">
                            <Breadcrumb>Settings</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-sales-accounts">
                            <BreadcrumbLink to={MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE}>
                                Sales accounts
                            </BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="sales-accounts-create-page">
                            <Breadcrumb>Create sales account</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <CreateUpdateSalesAccountForm
                ref={formRef}
                initialValues={prepareInitialValues()}
                onSubmit={(data) => {
                    callCreateSalesAccount({
                        salesAccount: {
                            ...data,
                            merchant: {
                                id: merchantId,
                            },
                        },
                    })
                }}
            />
        </>
    )
}
